// Constantes del formato binario del parque (NÚCLEO ESTABLE).
//
// Un fichero `.epcp` describe la GEOMETRÍA + CAPAS de UNA vista (hincados /
// estructuras / módulos) de un parque. Es inmutable salvo re-import/edición de la
// geometría. El ESTADO (status) NO va aquí: se obtiene en vivo de Mongo y el color
// se resuelve en cliente. Ver [[project_solarpark_binary_cache_design]].
//
// Todo little-endian. Los bloques grandes (geometría Float32, identidad Uint32)
// quedan alineados a 4 B para poder leerse ZERO-COPY como typed arrays.

export const EPCP_MAGIC = 'EPCP'          // 4 bytes al inicio
export const EPCP_VERSION = 1

// Código de vista (1 byte en el header).
export const VIEW_CODES = { structures: 0, pilings: 1, modules: 2 }
export const VIEW_NAMES = ['structures', 'pilings', 'modules']

// Tamaños fijos (bytes).
export const HEADER_BYTES = 16        // magic4 + version2 + viewCode1 + flags1 + picCount2 + pad2 + totalEntities4
export const DIR_ENTRY_BYTES = 12     // pictogramId4 + geomVersion4 + entityCount4
export const GEOM_BYTES = 16          // x,y,w,h : float32 × 4
export const ID_BYTES = 4             // entityId : uint32
export const LAYER_BYTES = 2          // layerCode : uint16

// Valor de layerCode cuando la entidad no referencia una capa conocida.
export const NO_LAYER = 0xFFFF
